<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoEditar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoEditar">
            <form #f="ngForm" name="form" novalidate>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="loading">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="mb-5">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div class="p-fluid p-formgrid grid" *ngIf="adiantamentoFolha && !loading">
                        <div class="field col-12 md:col-3">
                            <label htmlFor="profissional">Profissional</label>
                            <label class="form-control" id="profissional">
                                {{ adiantamentoFolha.nomeProfissional }}
                            </label>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valor">Valor</label>
                            <label class="form-control">
                                {{ adiantamentoFolha.valor | currency: "BRL" }}
                            </label>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="tipoPagamento">Forma de Pagamento</label>
                            <label class="form-control">
                                {{ adiantamentoFolha.descricaoTipoPagamento }}
                            </label>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="data">Data da Transação</label>
                            <label class="form-control" id="data">
                                {{ adiantamentoFolha.data | date: "dd/MM/yyyy" }}
                            </label>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="parcelas">Nº Parcelas</label>
                            <label class="form-control" id="parcelas">
                                {{ adiantamentoFolha.parcelas }}
                            </label>
                        </div>

                        <div class="field col-12 md:col-12">
                            <p-table
                                #dt1
                                [value]="parcelasAdiantamentoFolha"
                                dataKey="id"
                                [rows]="10"
                                [rowHover]="true"
                                styleClass="p-datatable-gridlines"
                                [paginator]="false"
                                responsiveLayout="scroll"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>
                                            <div>Data Registro</div>
                                        </th>
                                        <th>
                                            <div>Descrição</div>
                                        </th>
                                        <th>
                                            <div style="text-wrap: nowrap">Identificação</div>
                                        </th>
                                        <th>
                                            <div>Data a Cobrar</div>
                                        </th>
                                        <th>
                                            <div>Valor Registro</div>
                                        </th>
                                        <th>
                                            <div>Excluir</div>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item let-i="rowIndex">
                                    <tr>
                                        <td>
                                            <label>
                                                {{ item.dataRegistro | date: "dd/MM/yyyy" }}
                                            </label>
                                        </td>
                                        <td>
                                            <label>ADIANTAMENTO</label>
                                        </td>
                                        <td>
                                            <label>{{ item.descricao }}</label>
                                        </td>
                                        <td>
                                            <p-calendar
                                                [readonlyInput]="false"
                                                [showIcon]="true"
                                                dateFormat="dd/mm/yy"
                                                [showButtonBar]="true"
                                                name="dataCompetencia{{ i }}"
                                                ngModel
                                                [(ngModel)]="item.dataCompetencia"
                                                appendTo="body"
                                            ></p-calendar>
                                        </td>
                                        <td>
                                            <!-- <p-inputNumber
                                                name="valorRegistro{{ i }}"
                                                mode="currency"
                                                inputId="currency-brazil"
                                                currency="BRL"
                                                locale="pt-BR"
                                                [allowEmpty]="true"
                                                [(ngModel)]="item.valorRegistro"
                                            ></p-inputNumber> -->
                                            <label class="form-control">
                                                {{ item.valorRegistro | currency: "BRL" }}
                                            </label>
                                        </td>
                                        <td>
                                            <button
                                                *ngIf="
                                                    verificarPermissao(
                                                        'PERM_EXCLUIR_ADIANTAMENTO_FOLHA'
                                                    )
                                                "
                                                pButton
                                                pRipple
                                                pTooltip="Excluir"
                                                icon="pi pi-trash"
                                                (click)="excluirItemFolha(item.id)"
                                                class="p-button-danger mr-2 mb-2 sm"
                                            ></button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!loading">
                        <div class="col-12 md:col-4">
                            <button
                                *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                                type="button"
                                pButton
                                icon="pi pi-check"
                                label="Atualizar"
                                class="p-button-outlined p-button-success md:w-9rem"
                                (click)="atualizar()"
                                [disabled]="!adiantamentoFolha"
                            ></button>
                            <ng-template #exibirBotaoFalso>
                                <button
                                    type="button"
                                    pButton
                                    icon="pi pi-spin pi-spinner"
                                    label="Atualizar"
                                    class="p-button-outlined p-button-success md:w-9rem"
                                    disabled
                                ></button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/adiantamento"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
            <p-dialog
                header="Adiantamento Excluído"
                [(visible)]="exibirRedirecionar"
                [modal]="true"
                [style]="{ width: '50vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
                (onHide)="redirecionarListagem()"
            >
                <div class="flex justify-content-between">
                    <p>Você será redirecionado para a listagem</p>
                    <button
                        type="button"
                        pButton
                        label="OK"
                        class="p-button-primary"
                        routerLink="/apps/adiantamento"
                    ></button>
                </div>
            </p-dialog>
        </div>
    </div>
</div>
